import { reportApi } from '../http/httpClient'

export interface ReportTeams {
  name: string
  leader?: string
  manager?: string
  supervisor?: string
  members: number
  transactions: number
  transactions_value: number
  commission_value: number
  createdAt: string
}

export interface ReportTeamsResponse {
  teams: ReportTeams[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportTeamsParams {
  search?: string
  startDate?: string
  endDate?: string
  maxValue?: string
  minValue?: string
  minSales?: string
  maxSales?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportTeams(params?: ReportTeamsParams | undefined) {
  const { data } = await reportApi.get<ReportTeamsResponse>('/report/teams', {
    params,
  })

  return data
}
